/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_All_ReadyInputs */

const en_us2_recovery_all_ready = /** @type {(inputs: Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All recovered: no muscle carries fatigue from the last few days.`)
};

const pt_br2_recovery_all_ready = /** @type {(inputs: Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo recuperado: nenhum músculo carrega cansaço dos últimos dias.`)
};

const es_419_recovery_all_ready = /** @type {(inputs: Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo recuperado: ningún músculo arrastra cansancio de los últimos días.`)
};

const pt_pt2_recovery_all_ready = /** @type {(inputs: Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo recuperado: nenhum músculo carrega cansaço dos últimos dias.`)
};

const fr_fr2_recovery_all_ready = /** @type {(inputs: Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout est récupéré : aucun muscle ne garde de fatigue des derniers jours.`)
};

const de_de2_recovery_all_ready = /** @type {(inputs: Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles erholt: Kein Muskel trägt Ermüdung aus den letzten Tagen.`)
};

const it_it2_recovery_all_ready = /** @type {(inputs: Recovery_All_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto recuperato: nessun muscolo porta fatica degli ultimi giorni.`)
};

/**
* | output |
* | --- |
* | "All recovered: no muscle carries fatigue from the last few days." |
*
* @param {Recovery_All_ReadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_all_ready = /** @type {((inputs?: Recovery_All_ReadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_All_ReadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_all_ready(inputs)
	if (locale === "es-419") return es_419_recovery_all_ready(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_all_ready(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_all_ready(inputs)
	if (locale === "de-DE") return de_de2_recovery_all_ready(inputs)
	if (locale === "it-IT") return it_it2_recovery_all_ready(inputs)
	return en_us2_recovery_all_ready(inputs)
});
export { recovery_all_ready as "recovery.all_ready" }